<form [formGroup]="formGroup">
    <app-update-banner
        *ngIf="showStructureBanner"
        class="ems-structure-banner"
        [message]="structureBannerMessage"
        buttonLocalizationKey="aumico_annual_report_ems_structure_diff_apply"
        [dismissible]="true"
        (confirm)="onApplyStructureChanges()"
        (dismiss)="onDismissStructureBanner()"
    >
    </app-update-banner>

    <ham-accordion-item class="text-addition" [isOpened]="showIntro" (toggle)="showIntro = !showIntro">
        <div accordion-header class="text-addition-header">
            <span class="text-addition-title">
                {{ 'aumico_annual_report_ems_text_addition_above_title' | i18next }}
            </span>
            <span class="ham-icon text-addition-chevron" [class.is-open]="showIntro">
                <i class="chevron-down-icon"></i>
            </span>
        </div>
        <div accordion-body>
            <ham-tiptap-toolbar [editor]="tiptapEditorAbove" (imageSelected)="onTiptapImageSelectedAbove($event)">
                <div #tiptapHostAbove class="tiptap-editor"></div>
            </ham-tiptap-toolbar>
        </div>
    </ham-accordion-item>

    <div class="ems-card">
        <div class="ems-card-header">
            <div class="ems-card-heading">
                <h2 class="ems-card-title">{{ 'aumico_annual_report_ems_title' | i18next }}</h2>
            </div>
            <span
                class="add-column-button-wrap"
                [hamDisabledTooltip]="columnLimitReached ? ('aumico_annual_report_ems_add_column_limit' | i18next) : ''"
            >
                <button
                    type="button"
                    class="add-column-button"
                    [matMenuTriggerFor]="addColumnMenu"
                    [disabled]="columnLimitReached"
                >
                    {{ 'aumico_annual_report_ems_add_column' | i18next }} ▾
                </button>
            </span>
            <mat-menu #addColumnMenu="matMenu" class="column-type-menu">
                <div class="menu-section-label">
                    {{ 'aumico_annual_report_ems_column_type_select_label' | i18next }}
                </div>
                <button mat-menu-item class="column-type-option" (click)="onAddColumn('USERDEFINED')">
                    <span class="option-title">{{ 'aumico_annual_report_ems_column_type_value' | i18next }}</span>
                    <span class="option-description">
                        {{ 'aumico_annual_report_ems_column_type_value_description' | i18next }}
                    </span>
                </button>
                <button mat-menu-item class="column-type-option" (click)="onAddColumn('TOTAL')">
                    <span class="option-title">{{ 'aumico_annual_report_ems_column_type_total' | i18next }}</span>
                    <span class="option-description">
                        {{ 'aumico_annual_report_ems_column_type_total_description' | i18next }}
                    </span>
                </button>
            </mat-menu>
        </div>

        <aumico-annualReport-equity-movement-schedule-component
            *ngIf="!hasNoPreviousData"
            [columns]="previousColumns"
            [periodLabel]="
                periodLabel(
                    dates?.previousPeriodIsFullYear,
                    dates?.previousYearOpeningDate,
                    dates?.previousYearClosingDate
                )
            "
            [openingTitle]="previousOpeningTitle"
            [closingTitle]="previousClosingTitle"
            [closingDate]="dates?.previousYearClosingDate"
            (periodChange)="onPreviousPeriodChanged($event)"
            (columnRename)="onColumnRename($event)"
            (columnDelete)="onColumnDelete($event)"
            (columnToggleSource)="onColumnToggleSource($event)"
            (columnReorder)="onColumnReorder($event)"
        ></aumico-annualReport-equity-movement-schedule-component>

        <aumico-annualReport-equity-movement-schedule-component
            [columns]="currentColumns"
            [periodLabel]="
                periodLabel(
                    dates?.currentPeriodIsFullYear,
                    dates?.currentYearOpeningDate,
                    dates?.currentYearClosingDate
                )
            "
            [openingTitle]="currentOpeningTitle"
            [closingTitle]="currentClosingTitle"
            [closingDate]="dates?.currentYearClosingDate"
            (periodChange)="onCurrentPeriodChanged($event)"
            (columnRename)="onColumnRename($event)"
            (columnDelete)="onColumnDelete($event)"
            (columnToggleSource)="onColumnToggleSource($event)"
            (columnReorder)="onColumnReorder($event)"
        ></aumico-annualReport-equity-movement-schedule-component>
    </div>

    <ham-accordion-item class="text-addition" [isOpened]="showNote" (toggle)="showNote = !showNote">
        <div accordion-header class="text-addition-header">
            <span class="text-addition-title">
                {{ 'aumico_annual_report_ems_text_addition_below_title' | i18next }}
            </span>
            <span class="ham-icon text-addition-chevron" [class.is-open]="showNote">
                <i class="chevron-down-icon"></i>
            </span>
        </div>
        <div accordion-body>
            <ham-tiptap-toolbar [editor]="tiptapEditorBelow" (imageSelected)="onTiptapImageSelectedBelow($event)">
                <div #tiptapHostBelow class="tiptap-editor"></div>
            </ham-tiptap-toolbar>
        </div>
    </ham-accordion-item>
</form>

<ham-confirm-decline-modal
    *ngIf="columnPendingDelete != null"
    (cancel)="onCancelColumnDelete()"
    (action)="onConfirmColumnDelete()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_annual_report_delete_item_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
